import { render, staticRenderFns } from "./GreyLayout.vue?vue&type=template&id=76c51c5e&scoped=true&"
var script = {}
import style0 from "./GreyLayout.vue?vue&type=style&index=0&id=76c51c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c51c5e",
  null
  
)

export default component.exports